import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { class_type, string_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { tryFind, ofSeq, empty } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { compareArrays, equals, compare } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { ofSeq as ofSeq_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { empty as empty_1, singleton, append, collect, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Option_ofBool } from "../Shopfoo.Common/Common.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";

export class Access extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["View", "Edit"];
    }
}

export function Access_$reflection() {
    return union_type("Shopfoo.Domain.Types.Security.Access", [], Access, () => [[], []]);
}

export class Feat extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["About", "Admin", "Catalog", "Sales", "Warehouse"];
    }
}

export function Feat_$reflection() {
    return union_type("Shopfoo.Domain.Types.Security.Feat", [], Feat, () => [[], [], [], [], []]);
}

export const ClaimsModule_none = empty({
    Compare: compare,
});

export function ClaimsModule_single(feat, access) {
    return ofSeq([[feat, access]], {
        Compare: compare,
    });
}

export function ClaimsModule_toSet(claims) {
    return ofSeq_1(toList(delay(() => collect((matchValue) => {
        const activePatternResult = matchValue;
        const feat = activePatternResult[0];
        const access = activePatternResult[1];
        return append(singleton([feat, access]), delay(() => (equals(access, new Access(1, [])) ? singleton([feat, new Access(0, [])]) : empty_1())));
    }, claims))), {
        Compare: compareArrays,
    });
}

export class User extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Anonymous", "LoggedIn"];
    }
}

export function User_$reflection() {
    return union_type("Shopfoo.Domain.Types.Security.User", [], User, () => [[], [["userName", string_type], ["claims", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Feat_$reflection(), Access_$reflection()])]]]);
}

export function User__AccessTo_Z21948E14(user, feat) {
    if (user.tag === 1) {
        return tryFind(feat, user.fields[1]);
    }
    else {
        return undefined;
    }
}

export function User__CanAccess_Z21948E14(user, feat) {
    return User__AccessTo_Z21948E14(user, feat) != null;
}

export function $007CUserCanAccess$007C_$007C(feat, user) {
    return Option_ofBool(User__CanAccess_Z21948E14(user, feat));
}

export function $007CUserCanNotAccess$007C_$007C(feat, user) {
    return Option_ofBool(!User__CanAccess_Z21948E14(user, feat));
}

export class AuthToken extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["AuthToken"];
    }
}

export function AuthToken_$reflection() {
    return union_type("Shopfoo.Domain.Types.Security.AuthToken", [], AuthToken, () => [[["Item", string_type]]]);
}

export class AuthError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TokenInvalid", "UserUnauthorized"];
    }
}

export function AuthError_$reflection() {
    return union_type("Shopfoo.Domain.Types.Security.AuthError", [], AuthError, () => [[], []]);
}

export class Persona extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Guest", "CatalogEditor", "Sales", "ProductManager", "Administrator"];
    }
}

export function Persona_$reflection() {
    return union_type("Shopfoo.Domain.Types.Security.Persona", [], Persona, () => [[], [], [], [], []]);
}

export function Persona__get_Name(this$) {
    switch (this$.tag) {
        case 1:
            return "Catalog Editor";
        case 2:
            return "Sales";
        case 3:
            return "Product Manager";
        case 4:
            return "Administrator";
        default:
            return "Guest";
    }
}

export function Persona__get_Claims(this$) {
    switch (this$.tag) {
        case 1:
            return ofSeq([[new Feat(0, []), new Access(0, [])], [new Feat(2, []), new Access(1, [])], [new Feat(3, []), new Access(0, [])], [new Feat(4, []), new Access(0, [])]], {
                Compare: compare,
            });
        case 2:
            return ofSeq([[new Feat(0, []), new Access(0, [])], [new Feat(2, []), new Access(0, [])], [new Feat(3, []), new Access(1, [])], [new Feat(4, []), new Access(1, [])]], {
                Compare: compare,
            });
        case 3:
            return ofSeq([[new Feat(0, []), new Access(0, [])], [new Feat(2, []), new Access(1, [])], [new Feat(3, []), new Access(1, [])], [new Feat(4, []), new Access(1, [])]], {
                Compare: compare,
            });
        case 4:
            return ofSeq([[new Feat(0, []), new Access(0, [])], [new Feat(2, []), new Access(1, [])], [new Feat(3, []), new Access(1, [])], [new Feat(4, []), new Access(1, [])], [new Feat(1, []), new Access(1, [])]], {
                Compare: compare,
            });
        default:
            return ofSeq([[new Feat(0, []), new Access(0, [])], [new Feat(2, []), new Access(0, [])]], {
                Compare: compare,
            });
    }
}

export function Persona_get_All() {
    return ofArray([new Persona(0, []), new Persona(1, []), new Persona(2, []), new Persona(3, []), new Persona(4, [])]);
}

